module.exports = __webpack_public_path__ + "img/popTitle.696184a4.png";